import React from "react";
import { Link } from "react-router-dom";

export default function MainTitle() {
  const [isCopied, setIsCopied] = React.useState(false);
  const handleCopyClick = async () => {
    if (!isCopied) {
      setIsCopied(true);
      try {
        await navigator.clipboard.writeText("play.trexmine.com");
        // اینجا می‌توانید نوتیفیکیشن یا بازخورد به کاربر اضافه کنید
        console.log("آی‌پی با موفقیت کپی شد!");
      } catch (err) {
        console.error("کپی کردن ناموفق بود: ", err);
      }
      setTimeout(() => {
        setIsCopied(false);
      }, 3000);
    }
  };

  return (
    <div
      className="flex flex-col items-center relative z-10 mt-24"
      style={{ direction: "rtl" }}
    >
      {/* Two title above */}
      <div className="flex gap-x-2 items-center">
        <svg
          width="34"
          height="34"
          viewBox="0 0 34 34"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M17 0L20.5199 3.86341L25.5 2.27757L26.6167 7.38335L31.7224 8.5L30.1366 13.4801L34 17L30.1366 20.5199L31.7224 25.5L26.6167 26.6167L25.5 31.7224L20.5199 30.1366L17 34L13.4801 30.1366L8.5 31.7224L7.38335 26.6167L2.27757 25.5L3.86341 20.5199L0 17L3.86341 13.4801L2.27757 8.5L7.38335 7.38335L8.5 2.27757L13.4801 3.86341L17 0Z"
            fill="#D4FE00"
          ></path>
          <path
            d="M20.75 24.5H13.25C12.9425 24.5 12.6875 24.245 12.6875 23.9375C12.6875 23.63 12.9425 23.375 13.25 23.375H20.75C21.0575 23.375 21.3125 23.63 21.3125 23.9375C21.3125 24.245 21.0575 24.5 20.75 24.5Z"
            fill="#000000"
          ></path>
          <path
            d="M23.2625 12.14L20.2625 14.285C19.865 14.57 19.295 14.3975 19.1225 13.94L17.705 10.16C17.465 9.5075 16.5425 9.5075 16.3025 10.16L14.8775 13.9325C14.705 14.3975 14.1425 14.57 13.745 14.2775L10.745 12.1325C10.145 11.7125 9.35004 12.305 9.59754 13.0025L12.7175 21.74C12.8225 22.04 13.1075 22.235 13.4225 22.235H20.57C20.885 22.235 21.17 22.0325 21.275 21.74L24.395 13.0025C24.65 12.305 23.855 11.7125 23.2625 12.14ZM18.875 19.0625H15.125C14.8175 19.0625 14.5625 18.8075 14.5625 18.5C14.5625 18.1925 14.8175 17.9375 15.125 17.9375H18.875C19.1825 17.9375 19.4375 18.1925 19.4375 18.5C19.4375 18.8075 19.1825 19.0625 18.875 19.0625Z"
            fill="#000000"
          ></path>
        </svg>
        <span className="text-[#D1D1D1] text-base md:text-xl font-DanaMedium">
          برترین سرور ماینکرفت فارسی
        </span>
      </div>

      <div className="md:mt-10 mt-6 flex flex-col font-DanaDemiBold text-white items-center">
        <h1 className="md:text-5xl text-3xl">ماینکرفت وقتی میچسبه</h1>
        <div className="md:text-5xl text-2xl mt-4 bg-yellow-600/15 rounded-full py-5 px-7">
          که توی <span className="text-yellow-300">تیرکس ماین</span> بازی کنی
        </div>
        <p className="max-w-[725px] md:text-[22px] text-base font-Dana mt-5 text-center px-5">
          تیرکس ماین، یک سرور بازی برای تفریح و لذت بیشتر کاربرهای ماینکرافت
          هست، اگر تو هم ماین کرافت بازی میکنی، بهت پیشنهاد میکنم که سرور
          ماینکرفت تیرکس ماین رو یه بار امتحان کنی .
        </p>

        <div className="home-hero_content mt-5">
          <div className="stats flex items-center gap-2.5 mt-9">
            <div
              className="item flex items-center gap-1 md:text-[18px] text-xs px-[22px] md:py-5 py-3 rounded-xl 
             bg-gradient-to-br from-[rgb(24,27,36)] to-[rgb(24,27,36)]
             font-[var(--font-secondary)] border-t border-[rgb(41,45,57)] 
             backdrop-blur-md"
            >
              <div className="online-badge relative w-[6px] h-[6px] ml-[10px] rounded-full bg-red-400 "></div>
              <span>386</span> بازیکن آنلاین
            </div>

            <div
              className="copy-input relative item flex items-center gap-1 md:text-[18px] text-xs px-[22px] md:py-5 py-3 rounded-xl 
             bg-gradient-to-br from-[rgb(24,27,36)] to-[rgb(24,27,36)] 
             font-[var(--font-secondary)] border-t border-[rgb(41,45,57)] 
             backdrop-blur-md"
              onClick={handleCopyClick}
              aria-describedby=":r0:"
            >
              <div
                id="tooltip-default"
                role="tooltip"
                className="absolute -top-10 left-[15%] md:left-[25%] z-20 inline-block px-3 py-2 md:text-sm text-xs font-medium text-white transition-opacity duration-300 bg-gray-700 rounded-lg shadow-xs tooltip"
                style={{ userSelect: "all" }}
              >
                {isCopied ? "آیپی کپی شد" : "کپی کردن آیپی"}
                <div className="tooltip-arrow" data-popper-arrow></div>
              </div>
              play.trexmine.com
            </div>
          </div>
        </div>
      </div>
      <div className="flex mt-5 gap-x-3 ml-10">
        <Link
          to="/signup"
          className="btn-primary text-md px-6 rounded-lg py-3 text-black"
        >
          ورود / ثبت نام
        </Link>
        <Link
          to="/signup"
          className="btn-primary text-md px-6 rounded-lg py-3 text-black bg-white "
          style={{
            boxShadow: "0 4px 40px rgb(255 255 255 / 50%)",
          }}
        >
          اطلاعات بیشتر
        </Link>
      </div>
    </div>
  );
}
